import { SignalsServiceDefinition } from './core-services/signals/definition.js';
import { SignalsServiceFactory } from './core-services/signals/service.js';
const coreRegisgteredServices = createServicesMap().addService(SignalsServiceDefinition, SignalsServiceFactory, {});
export function createServicesManager(servicesBindings) {
    const bindingsByDefinition = new Map([
        ...servicesBindings.registeredServices,
        ...coreRegisgteredServices.registeredServices,
    ].map((service) => [service.definition, service]));
    const initializedServices = new Map();
    const manager = {
        getService(definition) {
            if (!initializedServices.has(definition)) {
                const service = bindingsByDefinition.get(definition);
                if (!service) {
                    // this needs meaningful error message
                    throw new Error(`Service ${definition} is not provided`);
                }
                initializedServices.set(definition, service.impl({
                    config: service.config,
                    getService: manager.getService,
                }));
            }
            return initializedServices.get(definition);
        },
        hasService(definition) {
            return bindingsByDefinition.has(definition);
        },
        addService(definition, impl, config) {
            if (!manager.hasService(definition)) {
                bindingsByDefinition.set(definition, { definition, impl, config });
            }
            else {
                // this needs meaningful error message
                throw new Error(`Service ${definition} is already provided`);
            }
        },
    };
    bindingsByDefinition.forEach(({ definition, impl, config }) => {
        initializedServices.set(definition, impl({
            config,
            getService: manager.getService,
        }));
    });
    return manager;
}
export function createServicesMap(registeredServices = []) {
    return {
        registeredServices,
        addService(definition, impl, config) {
            return createServicesMap([
                ...registeredServices,
                { definition, impl, config },
            ]);
        },
    };
}
